import { useEffect, useMemo, useState } from "react";
import { ButtonTypes, ListData_ValueTypes } from "../../../../../Definitions";
import { LC_DEVICE, LCDeviceArgs, LCDeviceResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/lcDevice";
import { GenericDeviceTable } from "../../../../../Components/ToolsComponents/genericDeviceDataTable";
import NewButton from "../../../../../Components/BaseComponents/newButton";
import ResetTableModal from "../../../../../Components/ToolsComponents/Modals/resetTableModal";
import { LC_TABLE_IDS } from "../../../../../Definitions/lcTableIds";
import { glyphs } from "../../../../../Styles";
import { useLazyQuery } from "@apollo/client";
import { useAicoConnection } from "../../../../../Components";

const columnsData = [
	{ headerValue: "ID", accessor: "id", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "device_id", accessor: "device_id", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "cpu_id", accessor: "cpu_id", type: ListData_ValueTypes.String, sort: true },
	{ headerValue: "power_supply", accessor: "power_supply", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "max_ac_ports", accessor: "max_ac_ports", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "device_type", accessor: "device_type", type: ListData_ValueTypes.Number, sort: true },
]

export default function DeviceDataTable() {
	const [isResetTableModalOpen, setIsResetTableModalOpen] = useState<boolean>(false);

	const { state: connectionState } = useAicoConnection();

	const [fetchData, {data, loading, error }] = useLazyQuery<LCDeviceResponse, LCDeviceArgs>(LC_DEVICE, { fetchPolicy: "network-only" });

	useEffect(() => {
		if (connectionState.deviceConnection) {
			fetchData({variables: connectionState.deviceConnection});
		}
	}, [connectionState.deviceConnection]);

	const tableData = useMemo(() => {
		return data?.controller.lcDevice?.map((e, i) => ({
			...e,
			id: e.device_id
		})) ?? [];
	}, [data]);

	return (
		<>
			<GenericDeviceTable
				title="Devices"
				columnsData={columnsData}
				data={tableData}
				loading={loading}
				error={error}
				onFetch={() => connectionState.deviceConnection && fetchData({ variables: connectionState.deviceConnection })}
				tabButtons={[
					<NewButton
						key="Reset table"
						content="Reset Table"
						startEnhancer={glyphs.ArrowReset({})}
						onClick={() => {
							setIsResetTableModalOpen(true);
						}}
						buttonType={ButtonTypes.tableButton}
						disabled={!connectionState.deviceConnection}
					/>
				]}
			/>
			{connectionState.deviceConnection && 
				<ResetTableModal
					isModalOpen={isResetTableModalOpen}
					closeModal={()=>{ setIsResetTableModalOpen(false) }}
					onSuccess={() => fetchData({ variables: connectionState.deviceConnection })}
					tableId={LC_TABLE_IDS.devicemaps}
				/>
			}
		</>
	)
}